module.exports = __webpack_public_path__ + "img/logo_monochrom.3edba3b9.png";